<script>
  import { fade } from "svelte/transition";
  import Alert from "../components/Alert.svelte";
  import Title from "../components/Title.svelte";
  import MenuIcons from "../components/MenuIcons.svelte";
  import ProfileCard from "../components/ProfileCard.svelte";
  import Navigationbar from "../components/Navigationbar.svelte";
  import { session } from "../components/js/store.js";
  let sessions;
  $: sessions;
  session.subscribe((value) => {
    sessions = value;
  });
  //scroll to top every page load
  window.scroll({
    top: 0,
    left: 0,
    behavior: "smooth",
  });

  //navigation
  let navigation = [];
  $: if (sessions.loggedin == true) {
    if (sessions.user.firstName != undefined) {
      navigation["message"] =
        sessions.user.firstName + " " + sessions.user.lastName;
    } else {
      navigation["message"] = "Selamat Datang";
    }
  } else {
    navigation["message"] = "Selamat Datang";
  }

  //alert
  let alert = [];

  function logOut() {
    localStorage.removeItem("t");
    window.history.go(0);
  }
</script>

<svelte:head>
  <title>Mikhub - Account</title>
</svelte:head>
{#if alert.length > 0}
  <div class="fixed bottom-0 right-0 z-50 w-full px-2 mx-auto mb-10 lg:w-auto">
    {#each alert as a}
      <Alert color={a.color} title={a.title} message={a.message} />
    {/each}
  </div>
{/if}

<Navigationbar backbtn="false" message={navigation["message"]} align="center" />
<main
  transition:fade
  class="max-w-screen-xl px-1 pt-24 mx-auto mb-32 lg:pt-24 md:pt-20 lg:px-0"
>
  <div class="flex flex-wrap items-center max-w-6xl pt-3 mx-auto lg:my-0 ">
    <!--Main Col-->
    <ProfileCard />
  </div>
  <div class="flex flex-wrap items-center max-w-6xl pt-10 mx-auto">
    <a
      class="block w-full px-4 py-3 my-1 bg-white rounded-md shadow-md cursor-pointer hover:text-gray-700"
      href="/akun/profile"
      ><div class="flex items-center justify-between">
        <span class="text-base text-gray-800">Profile</span>
        <span class="px-3 py-1 font-bold text-gray-100 bg-gray-400 rounded-lg"
          >&gt;</span
        >
      </div>
    </a>
    <a
      class="block w-full px-4 py-3 my-1 bg-white rounded-md shadow-md cursor-pointer hover:text-gray-700"
      href="/akun/password"
      ><div class="flex items-center justify-between">
        <span class="text-base text-gray-800">Password</span>
        <span class="px-3 py-1 font-bold text-gray-100 bg-gray-400 rounded-lg"
          >&gt;</span
        >
      </div>
    </a>

    <Title tipe="2" subtitle="" title="Session" />
    <button
      class="block w-full px-4 py-3 my-1 bg-white rounded-md shadow-md cursor-pointer hover:text-gray-700"
      on:click={logOut}
      ><div class="flex items-center justify-between">
        <span class="text-base text-red-600">Logout</span>
        <span class="px-3 py-1 font-bold text-gray-100 bg-gray-400 rounded-lg"
          >&gt;</span
        >
      </div>
    </button>
  </div>
</main>
